import { useEffect, useState } from "react";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import CustomSelect from "../../../component/CustomSelect";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Icons from "../../../myIcon/Icons";

const categoryEditEndpoint = ApiEndpoints.tmsIntegrationCategory.categoryEdit;
const categoryUpdateEndPoint = ApiEndpoints.tmsIntegrationCategory.categoryUpdate;
const StatusData = [{ _id: "1", name: "Disable" }, { _id: "0", name: "Enable" }];

export default function EditTmsIntegrationCategory({ show, onHide, catId }) {
  const [data, setData] = useState({ name: "", status: "" });

  useEffect(() => {
    const dataFetch = async () => {
      if (!catId) return;
      try {
        const response = await ApiRequest("GET", `${categoryEditEndpoint}${catId}`);
        setData(response?.tmsintegrationcategory || { name: "", status: "" });
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [catId]);

  const handleInputChange = (e) => setData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.name || !data.status) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const response = await ApiRequest("POST", categoryUpdateEndPoint, {
        tmsintegrationcategory_id: catId,
        name: data.name,
        status: data.status,
      });
      response.error ? toast.error(response.message) : toast.success(response.message);
      if (!response.error) onHide();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal className="add-modal-area" show={show} onHide={onHide} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
        <form onSubmit={handleSubmit}>
          <div className="add-page-inputs">
            <div className="col-lg-12"><div className="add-page-sections">Edit Integration Category</div></div>
            <div className="label-wrap-add"><label>Category<small>*</small></label></div>
            <input required name="name" value={data.name || ""} type="text" className="form-control" onChange={handleInputChange} />
          </div>
          <div className="add-page-inputs">
            <div className="label-wrap-add"><label>Status<small>*</small></label></div>
            <CustomSelect name="status" defaultValue={data.status} options={StatusData} placeholder="Select Status" onChange={handleInputChange} />
          </div>
          <button type="submit" className="default-btn">Save Changes<span></span></button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
